import React from 'react';
import {BsTwitter, BsInstagram, BsLinkedin, BsGithub} from 'react-icons/bs'

const SocialMedia = () => {
  return (
    <div className='app__social'>
        <div>
            <BsTwitter/>
        </div>
        <div>
            <BsInstagram/>
        </div>
        <div>
            <BsLinkedin/>
        </div>
        <div>
          <BsGithub/>
        </div>
    </div>
  )
}

export default SocialMedia